import { useAuth0 } from "@auth0/auth0-react";
import { Tooltip } from "@material-ui/core";
import { ReactComponent as CopyIconGray } from "assets/icons/CopyIconGray.svg";
import { getCurrency } from "helper/numberFormat";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { InputField } from "../../../../components/InputField";
import { MyCheckbox } from "../../../../components/MyCheckbox";

// console.log("localStorageData", localStorageData);
const LedgerAccountsView = ({ ledgerSubLedgerData, edit, formik }) => {
  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;
  const orgKey = localStorageData?.orgkey;
  const { getAccessTokenSilently } = useAuth0();

  const [disabled, setDisable] = useState(true);
  const [isCopied, setIsCopied] = useState(false);

  const [selectedReceivableAccount, setSelectedReceivableAccount] =
    useState(true);
  const currency = getCurrency();

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    formik.setFieldValue(name, type === "checkbox" ? checked : value);
    formik.setFieldValue(name, type === "checkbox" ? checked : value);
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  const getReceivableAccountsByID = async (type, id) => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getReceivableAccountsByID(
      token,
      formik?.values?.account_receivable
    )
      .then((res) => {
        setSelectedReceivableAccount({
          ar_id: res?.result?._id,
          ar_name: res?.result?.ar_name,
        });
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };

  useEffect(() => {
    if (formik?.values?.account_receivable) {
      getReceivableAccountsByID();
    }
  }, [formik?.values?.account_receivable]);


  const mainUrl = window.location.origin;
  const getLink = (path) => {
    const checkDomain =
      mainUrl === 'https://admin.eztmpl.dev' ||
        mainUrl === 'http://localhost:3000'
        ? `https://shalom.eztmpl.dev/donation/${path}`
        : mainUrl === 'https://admin.eztmpl.com'
          ? `https://demo.eztmpl.com/donation/${path}`
          : mainUrl === 'https://admin.easyshul.com'
            ? `https://${orgKey}.easyshul.com/donation/${path}`
            : mainUrl === 'https://admin-green.easyshul.com' ? `https://localhost.member-green.easyshul.com/donation/${path}` : null;
    return checkDomain
  }

  const copyDonationLinkHandler = () => {
    const id = formik.values?.ledgerforId;
    const path = formik.values?.ledger_checkbox ? `?ledger=${id}` : `?subledger=${id}`;
    const link = getLink(path);
    if (link) {
      navigator.clipboard.writeText(link);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    }
  }

  const isProgramSage = localStorageData?.quickBooks_information?.program === "sage";
  const isProgramOnline = localStorageData?.quickBooks_information?.program === "online";
  const isProgramDisable = localStorageData?.quickBooks_information?.program === "disable";

  return (
    <div>
      <div className="input-fields addnew-fields">
        <div className="billing-amount-details charge-type-fields mt-10">
          <div
            className="col-sm-5 position-relative billing-input-field pb-2 ml-5 mr-5"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            <InputField
              type="text"
              {...{
                formik,
                title: "Parent ",
                name: `parent_ledger`,
                placeholder: "Donations",
                value: formik.values?.parent_ledger,
              }}
              style={{
                border: "1px solid #B5B5C3",
                backgroundColor: "#E7E7EB",
              }}
            />{" "}
          </div>
          <div
            className="col-sm-5 position-relative billing-input-field charge-dollar-sign pb-2 ml-5"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            <InputField
              type="number"
              {...{
                formik,
                title: " Default Amount",
                name: `default_amount`,
                placeholder: "200.00",
                value: formik.values?.default_amount,
              }}
              onKeyDown={(e) => preventArrows(e)}
              style={{
                border: "1px solid #B5B5C3",
                backgroundColor: "#E7E7EB",
              }}
              handleChange={(e) => {
                formik.setFieldValue(
                  `default_amount`,
                  e.target.value.match(regex)[0]
                );
              }}
            />
            <span>
              {currency}
            </span>
          </div>
        </div>

        <div className="input-second-row billing-amount-details">
          <div className="col-sm-12 position-relative billing-input-field charge-dollar-sign pb-2 ml-1 col-md-4">
            <div
              className="col-md-11 col-sm-11"
              style={{
                pointerEvents: disabled && edit === false ? "none" : "initial",
              }}
            >
              <InputField
                type="number"
                {...{
                  formik,
                  title: " Amount Deductible ",
                  name: `amount_deductible`,
                  placeholder: "2",
                  value: formik.values?.amount_deductible,
                }}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
                handleChange={(e) => {
                  const val = e.target.value.match(regex)[0];
                  const maxVal = formik.values?.deductibleType === '%' ? 100 : 10000;
                  if (parseFloat(val) > maxVal) return;
                  formik.setFieldValue(`amount_deductible`, val);
                }}
              />
              <span>
                {formik.values?.deductibleType === "%" ? "%" : currency}
              </span>
            </div>
          </div>
          {/* <div className="col-sm-12 position-relative billing-input-field gateway-fee pb-2 col-md-4 ml-35">
            <div
              className="col-md-11 gateway-fee-input col-sm-11"
              style={{
                pointerEvents: disabled && edit === false ? "none" : "initial",
              }}
            >
              <InputField
                type="number"
                {...{
                  formik,
                  title: "Gateway Fee Override",
                  name: `gateway_fee_override `,
                  placeholder: "None",
                  value: formik.values?.gateway_fee_override,
                }}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
                handleChange={(e) => {
                  formik.setFieldValue(
                    `gateway_fee_override`,
                    e.target.value.match(regex)[0]
                  );
                }}
              />{" "}
            </div>
          </div> */}
        </div>
        <div className="d-flex pl-5  pt-5">
          <div
            className="col-sm-5 setting-field disabled-account-receivable"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            {/* <LabelField title={"Account Receivable"} /> */}
            {/* <Select
              {...{
                formik,
                name: `account_receivable`,
                checkValidation: false,
              }}
              classNamePrefix="react-select"
              onKeyDown={(e) => preventArrows(e)}
              styles={colourStyles}
              value={
                selectedReceivableAccount
                  ? {
                      label: selectedReceivableAccount?.ar_name,
                      value: selectedReceivableAccount?.ar_id,
                    }
                  : ""
              }
              isDisabled={false}
              style={{
                height: "48px",
                border: "1px solid #B5B5C3",
                backgroundColor: "#E7E7EB",
              }}
            /> */}
            <InputField
              {...{
                formik,
                title: "Account Receivable",
                name: "account_receivable",
              }}
              value={selectedReceivableAccount?.ar_name}
              onKeyDown={(e) => preventArrows(e)}
              style={{
                height: "48px",
                border: "1px solid #B5B5C3",
                backgroundColor: "#E7E7EB",
              }}
            />
          </div>
        </div>

        <div className="d-flex pl-5  pt-5">
          {(!isProgramDisable) && (
            <div
              className="col-sm-5 ml-5 setting-field"
              style={{
                pointerEvents: disabled && edit === false ? "none" : "initial",
              }}
            >
              {/* <LabelField title={"QuickBooks Name"} /> */}
              <InputField
                {...{
                  formik,
                  title: isProgramSage ? "Sage Name" : "QuickBooks Name",
                  name: "quickBooks_name",
                  placeholder: isProgramSage ? "Sage Name" : "QuickBooks Name",
                }}
                value={formik.values?.quickBooks_name}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  height: "48px",
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
              />
            </div>
          )}
          {(isProgramOnline || isProgramSage) && (
            <div
              className="col-sm-5 setting-field"
              style={{
                pointerEvents: disabled && edit === false ? "none" : "initial",
              }}
            >
              <InputField
                {...{
                  formik,
                  title: isProgramSage ? "Sage ID" : "QuickBooks ID",
                  name: "quickBooks_id",
                  placeholder: isProgramSage ? "Sage ID" : "QuickBooks ID",
                }}
                value={formik.values?.quickBooks_id}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  height: "48px",
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
              />
            </div>
          )}
        </div>
        {localStorageData?.quickBooks_information?.classes === true ? (
          <div className="d-flex pl-5  pt-5">
            <div
              className="col-sm-5 ml-5 setting-field"
              style={{
                pointerEvents: disabled && edit === false ? "none" : "initial",
              }}
            >
              {/* <LabelField title={"QuickBooks Name"} /> */}
              <InputField
                {...{
                  formik,
                  title: "QuickBooks Class Name",
                  name: "quickBooksClass_name",
                  placeholder: "QuickBooks Class Name",
                }}
                value={formik.values?.quickBooksClass_name}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  height: "48px",
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
              />
            </div>
            {localStorageData?.quickBooks_information?.program === "online" && (
              <div
                className="col-sm-5 setting-field"
                style={{
                  pointerEvents: disabled && edit === false ? "none" : "initial",
                }}
              >
                <InputField
                  {...{
                    formik,
                    title: "QuickBooks Class ID",
                    name: "quickBooksClass_id",
                    placeholder: "QuickBooks Class ID",
                  }}
                  value={formik.values?.quickBooksClass_id}
                  onKeyDown={(e) => preventArrows(e)}
                  style={{
                    height: "48px",
                    border: "1px solid #B5B5C3",
                    backgroundColor: "#E7E7EB",
                  }}
                />
              </div>
            )}
          </div>
        ) : (
          <div></div>
        )}
        <div className="d-flex  pl-5 ml-5 pt-5 mt-5">

          <div
            className="m-0 type-check-box pr-5 mr-5 position-relative d-flex align-items-center"
          >
            <div
              style={{
                pointerEvents: disabled && edit === false ? "none" : "initial",
              }}
            >
              <MyCheckbox
                name={`donation`}
                title="Donation"
                handlechange={onChange}
                checked={formik.values?.donation}
                value={formik.values?.donation}
              />
            </div>
            {formik.values?.donation && (
              <Tooltip title={isCopied ? "Copied" : "Copy donation link, clicking on the icon will copy the dedicated link to the specific ledger."}>
                <div
                  className="cursor-pointer"
                  style={{
                    padding: "0",
                    transform: "translate(15px, -4px)",
                  }}
                  onClick={copyDonationLinkHandler}
                >
                  <CopyIconGray />
                </div>
              </Tooltip>
            )}
          </div>
          <div
            className="m-0  type-check-box pl-5 ml-5"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            <MyCheckbox
              name={`require_notes`}
              title="Require Notes"
              handlechange={onChange}
              checked={formik.values?.require_notes}
              value={formik.values?.require_notes}
            />
          </div>
          <div
            className="m-0  type-check-box pl-5 ml-5"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            <MyCheckbox
              name={`archived`}
              title="Archived"
              handlechange={onChange}
              checked={formik.values?.archived}
              value={formik.values?.archived}
            />
          </div>
          <div
            className="m-0  type-check-box pl-5 ml-5"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            <MyCheckbox
              name={`defaultCOA`}
              title="Default for COA"
              handlechange={onChange}
              checked={formik.values?.defaultCOA}
              value={formik.values?.defaultCOA}
            />
          </div>
        </div>

        <div className="d-flex pl-5 ml-5 pt-3">
          <div
            className="m-0 type-check-box"
            style={{
              pointerEvents: disabled && edit === false ? "none" : "initial",
            }}
          >
            <MyCheckbox
              name={`showOnCheckout`}
              title="Show on checkout"
              handlechange={onChange}
              checked={formik.values?.showOnCheckout}
              value={formik.values?.showOnCheckout}
            />
          </div>
        </div>

        {formik.values?.showOnCheckout && (
          <div className="pl-5 ml-5 mt-4 col-sm-8">
            <div style={{ pointerEvents: disabled && edit === false ? "none" : "initial" }}>
              <InputField
                {...{ formik, title: "Title", name: "checkoutTitle" }}
                value={formik.values?.checkoutTitle}
                style={{ height: "48px", border: "1px solid #B5B5C3", backgroundColor: "#E7E7EB" }}
              />
            </div>
            <div style={{ pointerEvents: disabled && edit === false ? "none" : "initial" }}>
              <InputField
                {...{ formik, title: "Label", name: "checkoutLabel" }}
                value={formik.values?.checkoutLabel}
                style={{ height: "48px", border: "1px solid #B5B5C3", backgroundColor: "#E7E7EB" }}
              />
            </div>
            <div className="mt-3">
              <div style={{ fontSize: 12, color: "#4F4F4F", marginBottom: 6 }}>Amounts</div>
              <div className="d-flex flex-wrap">
                {(formik.values?.checkoutAmounts ?? []).map((amt) => (
                  <span key={amt} style={{ display: "inline-flex", alignItems: "center", backgroundColor: "#3699FF", color: "#fff", padding: "4px 10px", borderRadius: "4px", fontSize: "13px", marginRight: "8px", marginTop: "4px" }}>
                    {currency}{amt}
                  </span>
                ))}
              </div>
            </div>
            <div
              className="m-0 type-check-box mt-3"
              style={{ pointerEvents: disabled && edit === false ? "none" : "initial" }}
            >
              <MyCheckbox
                name={`checkoutAllowOther`}
                title="Allow other"
                handlechange={onChange}
                checked={formik.values?.checkoutAllowOther}
                value={formik.values?.checkoutAllowOther}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LedgerAccountsView;
